import serves from "@/http";
import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionUserCadastro = ({dispatch},payload)=>{
    return serves.auth.cadastro(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
      
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDadosPessoais = ({dispatch},payload)=>{
    return serves.auth.dadospessoais(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
      
        dispatch('ActionSetMsg',err)
    })
}
export const ActionPessoaisEditar = ({dispatch},payload)=>{
    return serves.auth.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLogin = ({dispatch},payload)=>{
    return serves.auth.login(payload).then(res => {
        dispatch('ActionSetToken',res.data.access_token)
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSignOut')
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLogout = ({dispatch},payload)=>{
    return serves.auth.logout(payload).then(res => {
        dispatch('ActionSignOut')
    }).catch(err => {
        dispatch('ActionSignOut')
        dispatch('ActionSetMsg',err)
    })
}
export const ActionRecuperaSenha = ({dispatch},payload)=>{
    return serves.auth.recupera(payload).then(res=>{
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionVerificarCondigo = ({dispatch},payload)=>{
    return serves.auth.verificacodigo(payload).then(res=>{
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCadastraSenha = ({dispatch},payload)=>{
    return serves.auth.cadastrosenha(payload).then(res=>{
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionUpdateSenha = ({dispatch},payload)=>{
    return serves.auth.updatesenha(payload).then(res=>{
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionListaNotificacao = ({dispatch},payload)=>{
    return serves.auth.listanotificacao(payload).then(res=>{
        dispatch('ActionSetListaNotificacao',res)
    }).catch(err => {
        dispatch('ActionSetListaNotificacao',err)
    })
}
export const ActionEditNotificacao = ({dispatch},payload)=>{
    return serves.auth.editanotificacao(payload).then(res=>{
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDeleteNotificacao = ({dispatch},payload)=>{
    return serves.auth.deletenotificacao(payload).then(res=>{
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCheckToken = ({dispatch, state})=>{ 
    
    if (state.token) {
        
        return Promise.resolve.apply(state.token)
    }
    const token = storage.getLocalToken();
   
    if (!token) {
        console.log(state);
        return Promise.reject(new Error('Token Inválido'))
    }
   
    dispatch('ActionSetToken',token)
    
    return dispatch('ActionSession')
}
// export const ActionSession = ({dispatch})=>{
   
//     return new Promise(async (resolve,reject) => {
       
//         try {
//             // const {data:{user}} = await serves.auth.session()
//             await serves.auth.session().then(res => {
//                 console.log(res);
//                 dispatch('ActionSetUser',res.data)
//             }).catch(err => {
//                 dispatch('ActionSetUser',err)
//                 dispatch('ActionSignOut')
//             })
           
//             // dispatch('ActionSetUser',user)
//             resolve()
//         } catch (error) {
//             reject(error)
//         }
//     })
// }
export const ActionSession = async ({ dispatch }) => {
    try {
        const res = await serves.auth.session();
        console.log(res);
        dispatch('ActionSetUser', res.data);
    } catch (err) {
        dispatch('ActionSetUser', err);
        dispatch('ActionSignOut');
    }
};
export const ActionSessionTrabalhador = ({dispatch})=>{
    return  serves.auth.session().then(res => {
        dispatch('ActionSetUser',res.data)
    }).catch(err => {
        dispatch('ActionSetUser',err)
    })
}
export const ActionConfiguracaoGeral = ({dispatch},payload)=>{
    
    dispatch('ActionSetConfiguracaoGeral',payload)
}
export const ActionSetUser = ({commit},payload) =>{
    commit(types.SET_USER,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetToken = ({commit},payload) =>{
    storage.setHeaderToken(payload)
    storage.setLocalToken(payload)
    commit(types.SET_TOKEN,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetConfiguracaoGeral = ({commit},payload) =>{
    commit(types.SET_CONFIGURACAOGERAL,payload)
}
export const ActionSignOut = ({dispatch})=>{
    storage.setHeaderToken('');
    storage.deleteLocalToken();
    dispatch('ActionSetToken','');
}

export const ActionSetListaNotificacao = ({commit},payload) =>{
    commit(types.SET_LISTANOTIFICACAO,payload)
}